export default {"src":"/_next/static/media/delete-gray-simple.93b09109.svg","height":14,"width":13};